import request from '@/utils/http'

// 获取账号列表:
function getSysUserList (params: any, query: any) {
  return request({
    url: `sysUser/list/${params.pageNo}/${params.pageSize}`,
    method: 'post',
    data: { ...query }
  })
}

// 新建管理员:
function sysUserSave (params: any) {
  return request({
    url: `sysUser/save`,
    method: 'post',
    data: params
  })
}

// 修改管理员:
function sysUserUpdate (params: any) {
  return request({
    url: `sysUser/update`,
    method: 'put',
    data: params
  })
}

// 修改自己密码:
function sysUserUpdatePassword (params: any) {
  return request({
    url: `sysUser/updatePassword`,
    method: 'put',
    data: params
  })
}

// 管理员修改他人密码：
function sysUserAdminUpdatePassword (params: any) {
  return request({
    url: `sysUser/adminUpdatePassword`,
    method: 'put',
    data: params
  })
}

// 删除账号:
function delSysUserById (params: any) {
  return request({
    url: `sysUser/${params.id}`,
    method: 'delete'
  })
}

// 给用户添加角色:
function sysUserAddRole (params: any) {
  return request({
    url: `sysUser/addRole`,
    method: 'post',
    data: params
  })
}

// 获取用户的所有角色:
function sysUserGetUserRoles (params: any) {
  return request({
    url: `sysUser/getUserRoles/${params.userId}`,
    method: 'get'
  })
}

// 禁用账号:
function sysUserEnable (params: any) {
  return request({
    url: `sysUser/enable/${params.id}`,
    method: 'get'
  })
}

// 获取单个账号信息:
function getSysUserInfo (params: any) {
  return request({
    url: `sysUser/${params.id}`,
    method: 'get'
  })
}

// 单独绑定账号可以访问的组织架构节点：
function sysUserSaveUserOrganization (params: any) {
  return request({
    url: `sysUser/saveUserOrganization`,
    method: 'post',
    data: params
  })
}

// 查询账号可以访问的组织架构节点：
function sysUsergetUserOrganization (params: any) {
  return request({
    url: `sysUser/getUserOrganization/${params.userId}`,
    method: 'get'
  })
}

// 批量ID查询：
function sysUserSelectListByIds (params: any) {
  return request({
    url: `sysUser/selectListByIds`,
    method: 'post',
    data: params
  })
}

export default {
  getSysUserList,
  sysUserSave,
  sysUserUpdate,
  sysUserUpdatePassword,
  sysUserAdminUpdatePassword,
  delSysUserById,
  sysUserAddRole,
  sysUserGetUserRoles,
  sysUserEnable,
  getSysUserInfo,
  sysUserSaveUserOrganization,
  sysUsergetUserOrganization,
  sysUserSelectListByIds
}
